<template lang="html">
  <div class="projects-container">
    <svg version="1.1" id="Layer_2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    	 width="310.548px" height="50.507px" viewBox="0 0 310.548 50.507" enable-background="new 0 0 310.548 50.507"
    	 xml:space="preserve">
    <g>
    	<path class="projects-path" d="M24.377,3.979c10.853,0.254,14.602,7.067,13.637,14.124c-1.871,13.673-16.709,14.608-22.867,14.698l-2.104,15.561
    		c-0.054,0.4-0.468,0.662-0.752,0.662H2.329c-0.401,0-0.611-0.379-0.573-0.662L7.667,4.642c0.054-0.4,0.467-0.662,0.752-0.662
    		H24.377z M3.17,47.699h8.638l2.103-15.554c0.043-0.322,0.369-0.66,0.747-0.662c6.104-0.044,20.293-0.68,22.031-13.383
    		c0.875-6.396-2.348-12.559-12.506-12.797H8.902L3.17,47.699z M14.986,24.196l1.569-11.605c0.039-0.284,0.351-0.662,0.752-0.662
    		c5.693,0,10.933,0.999,10.171,6.494c-0.811,5.85-7.201,6.334-11.905,6.436C15.185,24.867,14.938,24.552,14.986,24.196z
    		 M26.154,18.418c0.555-4.005-2.91-5.077-8.364-5.159l-1.387,10.258C21.229,23.362,25.571,22.62,26.154,18.418z"/>
    	<path class="projects-path" d="M62.061,3.979c10.854,0.254,14.602,7.067,13.637,14.124c-0.898,6.561-4.88,10.255-9.392,12.261l9.216,17.633
    		c0,0,0.589,1.027-0.692,1.027h-10.97c-0.225,0-0.423-0.125-0.514-0.3l-8.313-15.993c-0.872,0.044-1.623,0.062-2.202,0.07
    		l-2.104,15.561c-0.054,0.4-0.468,0.662-0.752,0.662h-9.963c-0.401,0-0.611-0.379-0.573-0.662L45.35,4.642
    		c0.054-0.4,0.467-0.662,0.752-0.662H62.061z M40.853,47.699h8.638l2.103-15.554c0.043-0.322,0.369-0.66,0.747-0.662
    		c0.888-0.006,1.971-0.025,3.178-0.096c0.203-0.012,0.446,0.094,0.553,0.299l8.324,16.013h9.383l-9.02-17.26
    		c-0.318-0.608,0.247-0.903,0.429-0.976c4.475-1.775,8.318-5.027,9.185-11.363c0.875-6.396-2.348-12.559-12.506-12.797H46.585
    		L40.853,47.699z M52.669,24.196l1.569-11.605c0.039-0.284,0.351-0.662,0.752-0.662c5.692,0,10.933,0.999,10.171,6.494
    		c-0.811,5.85-7.201,6.334-11.905,6.436C52.868,24.867,52.621,24.552,52.669,24.196z M63.837,18.418
    		c0.555-4.005-2.91-5.077-8.364-5.159l-1.387,10.258C58.913,23.362,63.254,22.62,63.837,18.418z"/>
    	<path class="projects-path" d="M105.699,3.185c12.683,0,21.215,10.652,19.506,23.291c-1.708,12.637-13.126,23.344-25.811,23.344
    		c-12.683,0-21.26-10.704-19.551-23.344C81.552,13.834,93.019,3.185,105.699,3.185z M99.573,48.494
    		c11.905,0,22.691-10.067,24.307-22.019c1.616-11.95-6.454-21.967-18.36-21.967c-11.908,0-22.738,10.019-24.353,21.967
    		C79.552,38.425,87.667,48.494,99.573,48.494z M104.324,13.359c7.171,0,11.935,5.99,10.972,13.116
    		c-0.963,7.123-7.35,13.169-14.525,13.169c-7.173,0-11.981-6.042-11.018-13.169C90.716,19.346,97.155,13.359,104.324,13.359z
    		 M100.949,38.319c6.391,0,12.15-5.4,13.021-11.844c0.871-6.441-3.431-11.791-9.826-11.791c-6.397,0-12.197,5.354-13.067,11.791
    		C90.207,32.915,94.555,38.319,100.949,38.319z"/>
    	<path class="projects-path" d="M155.584,36.015c-1.207,8.928-7.106,13.805-16.148,13.805c-6.29,0-11.691-0.532-11.704-0.533
    		c-0.16-0.016-0.792-0.131-0.447-0.869l4.469-9.539c0.139-0.296,0.469-0.482,0.765-0.448c0,0,4.528,0.526,7.008,0.526
    		c2.491,0,4.556-1.359,5.113-5.485l3.898-28.829c0.054-0.4,0.468-0.662,0.752-0.662h9.963c0.401,0,0.611,0.378,0.573,0.662
    		L155.584,36.015z M149.774,5.304l-3.808,28.167c-0.632,4.671-3.386,6.81-6.618,6.81c-2.082,0-5.337-0.334-6.631-0.476l-3.858,8.235
    		c1.66,0.139,5.99,0.454,10.756,0.454c8.446,0,13.53-4.238,14.645-12.479l4.152-30.711H149.774z"/>
    	<path class="projects-path" d="M190.549,13.386c-0.054,0.401-0.468,0.662-0.752,0.662h-14.388l-0.996,7.367h13.752c0.401,0,0.611,0.377,0.573,0.662
    		l-1.182,8.744c-0.054,0.4-0.468,0.662-0.752,0.662h-13.751l-1.01,7.473h14.388c0.401,0,0.611,0.377,0.573,0.662l-1.182,8.744
    		c-0.054,0.4-0.468,0.662-0.752,0.662h-25.013c-0.401,0-0.611-0.379-0.573-0.662l5.911-43.721c0.054-0.4,0.468-0.662,0.752-0.662
    		h25.013c0.401,0,0.611,0.378,0.573,0.662L190.549,13.386z M166.629,5.304l-5.732,42.396h23.688l1.003-7.419H171.2
    		c-0.284,0-0.627-0.262-0.573-0.662l1.189-8.797c0.039-0.285,0.351-0.663,0.752-0.663h13.752l1.003-7.419h-13.752
    		c-0.284,0-0.627-0.262-0.573-0.662l1.175-8.691c0.039-0.284,0.351-0.662,0.752-0.662h14.388l1.003-7.42H166.629z"/>
    	<path class="projects-path" d="M215.383,49.819c-12.681,0-22.956-10.32-21.209-23.238c1.753-12.965,14.775-23.396,27.514-23.396
    		c9.583,0,12.563,2.146,12.681,2.232c0.207,0.154,0.271,0.443,0.184,0.689l-3.445,9.805c-0.022,0.062-0.279,0.881-1.024,0.441
    		c0,0-3.42-2.039-8.363-2.039c-9.643,0-14.653,6.662-15.396,12.162c-0.751,5.555,2.459,12.215,12.101,12.215
    		c4.942,0,8.914-2.039,8.914-2.039c0.061-0.031,0.833-0.454,0.905,0.441l0.794,9.805c0.022,0.271-0.152,0.547-0.362,0.684
    		C228.486,47.698,224.931,49.819,215.383,49.819z M226.978,38.194c-1.49,0.623-4.831,1.82-8.732,1.82
    		c-10.39,0-14.085-7.33-13.246-13.539c0.833-6.158,6.511-13.487,16.9-13.487c3.888,0,6.838,1.161,8.24,1.821l2.986-8.498
    		c-0.955-0.488-4.218-1.803-11.617-1.803c-12.062,0-24.367,9.919-26.01,22.072c-1.636,12.096,8.049,21.913,20.063,21.913
    		c7.366,0,10.964-1.29,12.104-1.803L226.978,38.194z"/>
    	<path class="projects-path" d="M239.142,4.642c0.055-0.4,0.468-0.662,0.752-0.662h30.736c0.401,0,0.611,0.378,0.573,0.662l-1.182,8.744
    		c-0.054,0.401-0.468,0.662-0.752,0.662h-9.725l-4.639,34.314c-0.054,0.4-0.468,0.662-0.752,0.662h-9.963
    		c-0.401,0-0.611-0.379-0.573-0.662l4.639-34.314h-9.724c-0.401,0-0.611-0.377-0.573-0.662L239.142,4.642z M249.099,12.724
    		c0.285,0,0.627,0.262,0.573,0.662l-4.64,34.313h8.638l4.639-34.313c0.039-0.284,0.351-0.662,0.752-0.662h9.725l1.003-7.42h-29.412
    		l-1.003,7.42H249.099z"/>
    	<path class="projects-path" d="M288.717,38.754c2.567,0.009,4.146-0.86,4.451-3.11c0.808-5.975-17.135-7.705-15.683-18.441
    		c0.321-2.373,1.267-4.766,2.757-6.89c4.75-6.772,14.868-10.593,27.378-2.908c0.291,0.179,0.332,0.586,0.146,0.876l-5.103,7.949
    		c-0.053,0.082-0.475,0.77-1.053,0.199c-2.221-2.189-4.748-3.016-6.981-3.022c-3.396-0.011-5.803,1.827-6.019,3.425
    		c-0.492,3.639,18.605,5.455,16.878,18.229c-0.357,2.642-1.609,5.269-3.521,7.554c-6.126,7.322-18.985,11.114-31.629,1.309
    		c-0.254-0.197-0.284-0.588-0.07-0.881l6.114-8.373c0.211-0.29,0.642-0.465,0.978-0.203
    		C280.314,36.762,285.167,38.742,288.717,38.754z M271.704,43.187c12.156,9.088,24.001,5.168,29.433-1.517
    		c1.659-2.042,2.719-4.338,3.026-6.609c1.569-11.604-17.681-12.29-16.878-18.229c0.374-2.766,3.84-4.762,7.527-4.75
    		c2.361,0.008,4.899,0.792,7.224,2.811l4.264-6.643c-11.968-7.066-20.988-3.16-25.108,2.881c-1.284,1.883-2.102,3.992-2.383,6.072
    		c-1.256,9.293,16.75,10.552,15.684,18.441c-0.436,3.221-3.088,4.444-5.959,4.436c-3.753-0.013-8.391-1.868-11.546-4.129
    		L271.704,43.187z"/>
    </g>
    </svg>

    <div class="paper-project-container clearfix">
      <h3>Paper</h3>
      <div class="left-text-container">
        <p><strong>TLDR:</strong> Paper is a financial news PWA which allows the user to follow companies listed on the NASDAQ. Up to five companies can be selected at once, with their 1 month historical prices charted, and the news feed customised to only return news pertaining to these shares.</p>
        <p><strong>The tech:</strong> This project is built with React and React Router. State and API calls are managed with Redux. The site is optimised as a PWA using webpack-pwa-plugin and service workers. The live project is hosted on Netlify.</p>
        <a target="_blank" href="https://github.com/andthomas/investment-app">View on GitHub</a> | <a target="_blank" href="https://paper-app.netlify.com/#/">Live Version</a>
      </div>
      <img class="right" src="https://res.cloudinary.com/djq5ic5br/image/upload/q_auto/fdsf_xcrdjz.gif" alt="">
    </div>

    <div class="voyager-project-container clearfix" style="margin-top: 40px">
      <h3>Outer Step</h3>
      <div class="right-text-container">
        <p><strong>TLDR:</strong> Outer Step is an Australian music festival. I built this website as a freelance developer to serve as a marketing and ticket sales platform. The site is optimised for fast loading times across browsers, while rich in assets and animations.</p>
        <p><strong>The tech:</strong> This project its built with Vue and hosted on Firebase. 
        It is integrated with Humanitix for ticket sales and Soundcloud for artist music samples.
        Scroll animations were built using ScrollMagic and TweenMax.</p>
        <a target="_blank" href="https://outer-step-staging.firebaseapp.com/">Live Version</a>
      </div>
      <img class="left" src="https://res.cloudinary.com/djq5ic5br/image/upload/q_auto/outer_dswnet.gif" alt="">
    </div>

    <div class="right-quick-project-container clearfix" style="margin-top: 40px">
      <h3>Right Quick</h3>
      <div class="left-text-container">
        <p><strong>TLDR:</strong> Right Quick is a game to test your typing
        skills with your right hand. I built this primarily as a rehabilitation
        tool for people recoving from a stroke.</p>
        <p><strong>The tech:</strong> This project is built with Vue. It uses VueX,
        ChartJS, and string-similarity.</p>
        <a target="_blank" href="https://github.com/andthomas/rightQuickTyping">View on GitHub</a> | <a target="_blank" href="https://andthomas.github.io/rightQuickTyping/#/">Live Version</a>
      </div>
      <img class="right" src="https://res.cloudinary.com/djq5ic5br/image/upload/q_auto/rightgif_gykgyc.gif" alt="">
    </div>

    <div class="fraga-project-container clearfix">
      <h3>Fråga</h3>
      <div class="right-text-container">
        <p><strong>TLDR:</strong> Fråga is the Swedish word for 'Ask'. The
        project is a location based social media platform, where posts are
        pinned to a specific location and can be commented on by people in that
        area.</p>
        <p><strong>The tech:</strong> This project is built with Ruby on Rails.
        Locations are detected by device and geocoded to a Google map.
        Translations are handled with Yandex.</p>
        <a target="_blank" href="https://github.com/aparkinbotswana/Fraga">View on GitHub</a> | <a target="_blank" href="https://fraqa.herokuapp.com/">Live Version</a>
      </div>
      <img class="left" src="https://res.cloudinary.com/djq5ic5br/image/upload/q_auto/fraggif_g9qit0.gif" alt="">
    </div>

    <div class="agility-project-container clearfix">
      <h3>Agility</h3>
      <div class="left-text-container">
        <p><strong>TLDR:</strong> Agility is a retro styled game for the browser, inspired by Pong and Frogger. I built this in order to 
        try out a few new ES6 features including class syntax, destructuring and new array methods.</p>
        <p><strong>The tech:</strong> This project is built with Vanilla JS, HTML and CSS.</p>
        <a target="_blank" href="https://github.com/andthomas/agility">View on GitHub</a> | <a target="_blank" href="https://andthomas.github.io/agility/">Live Version</a>
      </div>
      <img class="right" src="https://res.cloudinary.com/djq5ic5br/image/upload/q_auto/agility_zt6vzf.gif" alt="">
    </div>

  </div>
</template>

<script type="text/javascript">
  let controller = new ScrollMagic.Controller()
  export default {
    mounted() {

      let headingTween = TweenMax.to('#Layer_2', 1, { opacity:1 });
      let headingScene = new ScrollMagic.Scene({
        triggerElement: "#Layer_2",
        triggerHook: "onEnter",
        triggerHook: "0.8",
        reverse: false
      })
      .setTween(headingTween)
      .addTo(controller);

      let rightQuickTween = TweenMax.to('.right-quick-project-container', 1, { opacity:1  });
      let rightQuickScene = new ScrollMagic.Scene({
        triggerElement: ".right-quick-project-container",
        triggerHook: "onEnter",
        triggerHook: "0.8",
        reverse: false
      })
      .setTween(rightQuickTween)
      .addTo(controller);

      let paperTween = TweenMax.to('.paper-project-container', 1, { opacity:1  });
      let paperScene = new ScrollMagic.Scene({
        triggerElement: ".paper-project-container",
        triggerHook: "onEnter",
        triggerHook: "0.8",
        reverse: false
      })
      .setTween(paperTween)
      .addTo(controller);

      let fragaTween = TweenMax.to('.fraga-project-container', 1, { opacity:1  });
      let fragaScene = new ScrollMagic.Scene({
        triggerElement: ".fraga-project-container",
        triggerHook: "onEnter",
        triggerHook: "0.8",
        reverse: false
      })
      .setTween(fragaTween)
      .addTo(controller);

      let voyagerTween = TweenMax.to('.voyager-project-container', 1, { opacity:1  });
      let voyagerScene = new ScrollMagic.Scene({
        triggerElement: ".voyager-project-container",
        triggerHook: "onEnter",
        triggerHook: "0.8",
        reverse: false
      })
      .setTween(voyagerTween)
      .addTo(controller);

      let agilityTween = TweenMax.to('.agility-project-container', 1, { opacity:1  });
      let agilityScene = new ScrollMagic.Scene({
        triggerElement: ".agility-project-container",
        triggerHook: "onEnter",
        triggerHook: "0.8",
        reverse: false
      })
      .setTween(agilityTween)
      .addTo(controller);
    }
  }
</script>

<style lang="css">

  .projects-container {
    padding-top: 20px;
    margin-top: 60px;
  }
  .left-text-container {
    float: left; 
    width: 45%;
  }
  .right-text-container {
    float: right; 
    width: 45%;
  }

  #fraga {
    height: 100%;
    float: right;
    display: block;
    transition: transform 1s;
    cursor: pointer;
  }

  #happyhour {
    height: 100%;
    display: block;
    transition: transform 1s;
    cursor: pointer;
  }

  #voyager {
    height: 100%;
    display: block;
    float: right;
    transition: transform 1s;
    cursor: pointer;
  }
  .item {
      overflow: hidden;
  }
  .item:hover>img {
    -moz-transform: scale(1.1);
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  .projects-path {
    fill: none;
    stroke:#A8A030;
  }

  #Layer_2 {
    display: block;
    /* max-width: 80%; */
    /* margin-top: 70px; */
    margin-bottom: 70px;
    opacity: 0;
  }

  .paper-project-container, .right-quick-project-container, .fraga-project-container, .voyager-project-container, .agility-project-container {
    opacity: 0;
  }

  h3 {
    padding-top: 10px;
  }

  .right {
    width: 45%; 
    float: right;
  }

  .left {
    width: 45%; 
    float: left;
  }

  /* MOBILE RESPONSIVE */
	@media only screen and (max-width: 700px) {
    .outerstep-container {
      width: 100%;
    }

    .right-text-container, .left-text-container {
      width: 100%;
    }

    .right-quick-project-container, .voyager-project-container {
      margin-top: 80px !important;
    }

    .right, .left {
      width: 100%; 
      float: none;
      margin: 0 auto;
      display: block;
      padding-top: 40px;
    }

    .fraga-project-container, .agility-project-container {
      display: none;
    }

    #Layer_2 {
      max-width: 80%;
      margin-bottom: 20px;
    }

    h3 {
      margin-bottom: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// Projects.vue?81948af6